<template>
    <div class="content_box mobile_content">
        <div class="top">
            <div class="title">
                <span>用户管理</span>
            </div>&nbsp;&nbsp;
            <el-select v-model="region" placeholder="请选择" class="region-select" @change="regionChanged">
                <el-option label="美洲数据中心" value="us"></el-option>
                <el-option label="中国数据中心" value="cn"></el-option>
                <el-option label="欧洲数据中心" value="eu"></el-option>
                <el-option label="亚太数据中心" value="ap"></el-option>
            </el-select>
        </div>
        <div class="area">
            <div class="content">
                <div class="search_box">
                    <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="90px">
                        <el-form-item>
                            <el-select v-model="searchData.country" filterable clearable placeholder="国家/地区">
                                <el-option :label="item.chinese" :value="item.chinese"
                                    v-for="(item,i) in countryList" :key="item.chinese + i"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="searchData.status" placeholder="状态">
                                <el-option label="全部状态" :value="-1"></el-option>
                                <el-option label="正常" :value="1"></el-option>
                                <el-option label="注销" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户名" class="form_item">
                            <el-input placeholder="请输入" v-model="searchData.username"></el-input>
                        </el-form-item>
                        <el-form-item label="注册时间" class="form_item date_picker">
                            <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                        </el-form-item>
                        <el-form-item>
                            <div class="button search" @click="search">
                                <span>查询</span>
                            </div>
                            <div class="button search white" @click="init">
                                <span>重置</span>
                            </div>
                            <div class="button search button2" @click="createUser" v-if="roleCheck('104-101-101-103')">
                                <span>创建用户</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table :data="userList" :fit="true" style="width:100%" @sort-change="sortChange" highlight-current-row :default-sort = "{prop: 'create_time', order: 'descending'}">
                    <el-table-column prop="username" label="用户名" min-width="130"></el-table-column>
                    <el-table-column prop="country" label="国家/地区">
                         <template slot-scope="scope">
                            <span>{{(scope.row.country && scope.row.country != '0') ? scope.row.country : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <span :class="scope.row.status ? 'normal' : 'destroy'">{{scope.row.status ? '正常' : '注销'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" sortable label="注册时间" min-width="160">
                        <template slot-scope="scope">
                            <span>{{scope.row.create_time > 0 ? formDate(scope.row.create_time) : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_time" sortable label="最后活跃时间" min-width="160">
                        <template slot-scope="scope">
                            <span>{{scope.row.last_time > 0 ? formDate(scope.row.last_time) : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ali_user_id" label="操作" width="160">
                        <template slot-scope="scope">
                            <div class="btn">
                                <div class="button text" @click.stop="goDetail(scope.row)">
                                    <span>查看</span>
                                </div>
                                <div class="button text" @click="updateUserPwd(scope.row)" v-if="roleCheck('104-101-101-104')" >
                                    <span>编辑</span>
                                </div>
                                <div class="button text del_btn" @click="deleteUser(scope.row)" v-if="roleCheck('104-101-101-105')" >
                                    <span>注销</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            </div>
            <Gh-Dialog ref="userDialog" size="big" :title="actDislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <el-form-item label="国家" prop="userCountry" v-if="actDislog.type != 'delete'">
                            <el-select v-model="actData.userCountry" value-key="id" :disabled="actDislog.type == 'update'" placeholder="请选择国家" >
                                <el-option :label="item.chinese" :value="item" v-for="item in countryList" :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="账号" prop="account">
                            <el-input v-model="actData.account" :disabled="actDislog.type != 'add'" placeholder="请输入手机号/邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password" v-if="actDislog.type != 'delete'">
                            <el-input v-model="actData.password" minlength="8" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="sex" v-if="actDislog.type == 'add'">
                            <el-radio-group v-model="actData.sex">
                                <el-radio :label="1">男</el-radio>
                                <el-radio :label="2">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark" v-if="actDislog.type != 'add'">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" show-word-limit  v-model="actData.remark" placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: 'iot-user-manage',
    data() {
        return {
            region: 'us',
            searchData: {
                page_size: 10,
                page: 1,
                reg_start_time: '',
                reg_end_time: '',
                status: -1,
                country: '',
                order_by: 2
            },
            createTime: [],
            total: 0,
            userList: [],
            countryList: [],
            actDislog: {
                type: '',
                title: ''
            },
            actData: {},
            formRule: {
                userCountry: [this.requiredRule('请选择国家')],
                account: [this.requiredRule('请输入手机号或邮箱')],
                password: [this.requiredRule('请输入密码')],
                remark: [this.requiredRule('请输入备注信息')],
            },
        };
    },
    created() {
        if(!this.$route.query.region) {
            this.$router.replace('?region=us');
        }
        this.region = this.$route.query.region || this.region;
        this.getCountry();
        this.getUserList();
    },
    watch: {
        createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.reg_start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
                this.searchData.reg_end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            } else {
                this.searchData.reg_start_time = '';
                this.searchData.reg_end_time = '';
            }
        }
    },
    methods: {
        init() {
            this.searchData = {
                page_size: 10,
                page: 1,
                country: '',
                username: '',
                status: -1,
                reg_end_time: '',
                reg_start_time: '',
                order_by: 2
            };
            this.createTime = [];
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            this.userList = [];
            this.total = 0;
            this.search();
        },
        search() {
            this.searchData.page = 1;
            this.getUserList();
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.countryList = data.data.country;
            })
        },
        getUserList() {
            this.api.getIotUserList(this.searchData).then(data => {
                this.userList = data.data.list;
                this.total = data.data.total;
            })
        },
        sortChange(sort) {
            if(sort.prop == 'create_time') {
                if(!sort.order || sort.order == 'descending'){
                    this.searchData.order_by = 2;
                }else{
                    this.searchData.order_by = 1;
                }
            }else if(sort.prop == 'last_time') {
                if(!sort.order || sort.order == 'descending'){
                    this.searchData.order_by = 4;
                }else{
                    this.searchData.order_by = 3;
                }
            }
            this.search();
        },
        goDetail(row, column, event) {
            if (window.h5sdk) {
                this.$router.push({ name: 'user-detail', params: { id: row.ali_user_id }, query: {region: this.region}});
                return;
            }
            const page = this.$router.resolve({
                name: 'user-detail',
                params: {
                    id: row.ali_user_id
                },
                query: {
                    region: this.region
                }
            });
            window.open(page.href, "_blank");
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getUserList();
        },
        createUser() {
            this.actDislog = {
                type: 'add',
                title: '创建用户'
            };
            this.actData = {
                sex: 1
            };
            this.$refs.userDialog.show = true;
        },
        updateUserPwd(userInfo) {
            this.actDislog = {
                type: 'update',
                title: '编辑用户信息'
            };
            const country = this.countryList.filter(item => {
                return item.code == userInfo.area_code
            })
            this.actData = {
                region: this.region,
                country_code: userInfo.area_code,
                account: userInfo.username,
                ali_user_id: userInfo.ali_user_id,
                userCountry: country[0],
                remark: ''
            };
            this.$refs.userDialog.show = true;
        },
        deleteUser(userInfo) {
            this.actDislog = {
                type: 'delete',
                title: '注销用户'
            };
            this.actData = {
                region: this.region,
                account: userInfo.username,
                ali_user_id: userInfo.ali_user_id,
                remark: ''
            };
            this.$refs.userDialog.show = true;
        },
        updateConfirm() {
            this.$refs.formRule.validate(v => {
                if(v) {
                    if(this.actDislog.type == 'add') { //创建用户
                        const p = {
                            account: this.actData.account,
                            password: this.actData.password,
                            sex: this.actData.sex,
                            country_abbr: this.actData.userCountry.abbr,
                            country_code: parseInt(this.actData.userCountry.code)
                        };
                        this.api.createUser(p).then(data => {
                            if(data.code == 0 || data.code == 200) {
                                this.$message.success('操作成功！');
                                this.getUserList();
                                this.$refs.userDialog.show = false;
                            }
                            
                        })
                    }else if(this.actDislog.type == 'update'){  //编辑用户密码
                        const p = {...this.actData};
                        delete p.userCountry;
                        this.api.updateUserPwd(p).then(data => {
                            if(data.code == 0 || data.code == 200) {
                                this.$message.success('操作成功！');
                                this.getUserList();
                                this.$refs.userDialog.show = false;
                            }
                        })
                    }else if(this.actDislog.type == 'delete'){  //注销用户
                        this.api.delUser(this.actData).then(data => {
                            if(data.code == 0 || data.code == 200) {
                                this.$message.success('操作成功！');
                                this.getUserList();
                                this.$refs.userDialog.show = false;
                            }
                        })
                    }
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.content_box {
    padding: 0;

}

/deep/.top {
    .flexLayout(space-between);
    padding: 20px;
    background-color: @colorWhite;
    .el-input__inner{
        height: 32px;
        line-height: 32px;
    }
    .el-input__icon{
        line-height: 32px;
    }
    @media (max-width: 768px) {
        .el-input__inner{
            height: 28px;
            line-height: 28px;
        }
        .el-input__icon{
            line-height: 28px;
        }
    }
}

.area {
    padding: 20px;
    height: calc(100% - 80px);
    box-sizing: border-box;
    .normal{
        color: #00D6B9;
    }
    .destroy{
        color: #F8AF0C;
    }
    @media (max-width: 768px) {
        .el-form.form-list .el-form-item{
            margin-right: 0!important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/iot/user-manage/user-manage.vue